import React from 'react';
import Select from 'react-select';
import { InputLabel, FormControl, FormHelperText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import color from '../../assets/css/colors';
import { listSystemCode } from '../../services/CommonService';

const useStyles = makeStyles(() => ({
  textFieldWrapper: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
  },
  textLabel: {
    fontWeight: 640,
    color: color.default.main,
    marginBottom: 6,
  },
  selectField: {
    marginTop: 25,
    '& .select__control': {
      minHeight: '48px !important',
    },
    '& .css-1jqq78o-placeholder': {
      fontWeight: 'bold',
      opacity: 0.4,
    },
    '& .css-1nmdiq5-menu': {
      fontWeight: 640,
      color: color.default.main,
    },
  },
}));

export const SelectSourceOfFunds = (props) => {
  const classes = useStyles();

  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    if (options.length === 0) {
      getOptions();
    }
    // eslint-disable-next-line
  }, [props]);

  const getOptions = async () => {
    const { systemCodeList } = await listSystemCode({
      type: 'Fund Source',
      subType: '',
      orderBy: '',
    });

    let tempOptions = [];

    systemCodeList.forEach((element) => {
      tempOptions.push({
        value: element.description,
        label: element.description,
        name: props.name,
      });
    });

    setOptions(tempOptions);
  };

  return (
    <div className={classes.textFieldWrapper}>
      <FormControl
        fullWidth
        error={props.error}
        style={{
          marginTop: props.mt ? props.mt : 0,
          marginBottom: props.mb ? props.mb : 0,
        }}
      >
        <InputLabel
          htmlFor={props.name}
          className={props.disabled ? classes.disabled : ''}
          shrink
          required={props.required}
        >
          {props.label}
        </InputLabel>

        <Select
          id={props.name}
          className={classes.selectField}
          defaultValue={[]}
          isMulti
          options={options}
          classNamePrefix="select"
          name={props.name}
          disabled={props.disabled}
          required={props.required}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          InputLabelProps={{ shrink: true }}
        />
        {props.error && <FormHelperText>{props.error ? props.msg : ''}</FormHelperText>}
      </FormControl>
    </div>
  );
};
